import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import SportsRugbyIcon from "@mui/icons-material/SportsRugby";

const palette = {
  bg: "#EEF5FF",
  panel: "#B4D4FF",
  border: "#86B6F6",
  accent: "#176B87",
  ink: "#0B2230",
};

const NotFound: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minHeight: "80vh",
        backgroundColor: palette.bg,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 2,
        px: 2,
        textAlign: "center",
      }}
    >
      <Box
        sx={{
          width: 72,
          height: 72,
          borderRadius: 3,
          backgroundColor: palette.panel,
          border: `1px solid ${palette.border}`,
          display: "grid",
          placeItems: "center",
          mb: 1,
        }}
      >
        <SportsRugbyIcon sx={{ fontSize: 38, color: palette.accent }} />
      </Box>

      <Typography
        variant="h2"
        fontFamily="Poppins"
        fontWeight={1000}
        sx={{ color: palette.accent, lineHeight: 1 }}
      >
        404
      </Typography>

      <Typography
        variant="h6"
        fontFamily="Poppins"
        fontWeight={700}
        sx={{ color: palette.ink }}
      >
        Page not found
      </Typography>

      <Typography variant="body2" sx={{ color: "rgba(11,34,48,0.65)", maxWidth: 360 }}>
        This page doesn't exist. The ball's gone into touch — head back to the home page.
      </Typography>

      <Button
        variant="contained"
        onClick={() => navigate("/")}
        sx={{
          mt: 1,
          backgroundColor: palette.accent,
          borderRadius: 2,
          textTransform: "none",
          fontWeight: 800,
          px: 3,
          "&:hover": { backgroundColor: "#0F5268" },
        }}
      >
        Back to Home
      </Button>
    </Box>
  );
};

export default NotFound;
